import { CHECKOUT_PAGES } from '../config.js';

const findCheckoutPage = () => {
    const path = window.location.pathname;
    return CHECKOUT_PAGES.find((page) => path.includes(page)) || 'none';
};
const fetchWithTimeout = async (resource, timeout, customOptions, csrfToken) => {
    const abortController = new AbortController();
    const id = setTimeout(() => abortController.abort(), timeout);
    const options = {
        ...customOptions,
        headers: {
            'Content-Type': 'application/json',
            'X-Checkout-Page-Id': findCheckoutPage(),
            ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
        },
    };
    const response = await fetch(resource, {
        ...options,
        signal: abortController.signal,
    });
    clearTimeout(id);
    return response;
};

export { fetchWithTimeout, findCheckoutPage };
//# sourceMappingURL=http-client.js.map
